// For the remix app where we're using vite, use import.meta.env.SSR, since it allows for
// better tree-shaking (see https://vite.dev/guide/ssr.html#conditional-logic).
// For syndicated components, we're not currently using Vite to build, so we need to fall
// back to the `typeof document` check in that case.
export const isServer =
    (import.meta.env ? import.meta.env.SSR : typeof document === 'undefined') ||
    process.env.NODE_ENV === 'test'
